import { Button, Typography } from "@mui/material";
import React, { useCallback } from "react";
import { EditorModalType } from "./ComponentEditorContext";
import { useModalEditorDisplayContext } from "./ModalEditorContext";
import { usePathContext } from "./PathInfo";
import { conditionedAttribute } from "./Conditional/HelpersConditional";

interface OpenClickableAreasEditorButtonProps {
  propName: string;
  value: object;
  fullObject: any;
}

export function OpenClickableAreasEditorButton(props: OpenClickableAreasEditorButtonProps) {
  const { showModal, setModalContext } = useModalEditorDisplayContext();
  const { path } = usePathContext();

  const handleOpenClickableAreasEditor = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      const widths = conditionedAttribute(props.fullObject, "width");
      const heights = conditionedAttribute(props.fullObject, "height");
      setModalContext(
        path,
        { value: props.value, widths: widths, heights: heights },
        EditorModalType.clickableAreasEditor,
      );
      showModal();
    },
    [props.fullObject, props.value, setModalContext, path, showModal],
  );

  return (
    <>
      <Typography component={"span"}>{props.propName}: </Typography>
      <Button variant="outlined" onClick={(event) => handleOpenClickableAreasEditor(event)}>
        Edit clickable areas
      </Button>
    </>
  );
}
